import { render, staticRenderFns } from "./ManageStandardComments.vue?vue&type=template&id=107111d2"
import script from "./ManageStandardComments.vue?vue&type=script&lang=js"
export * from "./ManageStandardComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports